import { tabAccessControl } from "../../../_helpers/access-control";
import { store } from "../../../_store";
let disabledTab = true;
let id = null;

store.dispatch("CXSettings/loadCXSettings", "BOMAssemblyEnabled");

function BillOfMaterialsTabs(baseView) {
    let visibleAssemblyTab = false;
    const Settings = store.getters["CXSettings/getCXSettings"];

    if (Settings && Settings.SettingValue) {
        visibleAssemblyTab = Settings.SettingValue.toLowerCase() === "y";
    }

    if (baseView && baseView.mode == "create" && baseView.view === "bill-of-materials") {
        disabledTab = true;
    } else {
        disabledTab = false;
    }

    if (baseView && baseView.id) {
        id = baseView.id;
    }

    return [
        {
            text: "Header",
            path: baseView.mode === "create" && !baseView.id ? `/bill-of-materials/create` : baseView.mode == "edit" ? `/bill-of-materials/edit/${id}` : `/bill-of-materials/review/${id}`,
            applicationFeatureCode: "BillOfMaterial",
        },
        {
            text: "Processes",
            path: `/bill-of-materials-processes/${id}`,
            applicationFeatureCode: "BillOfMaterial", // TODO : Change Accordingly
            disabled: disabledTab
        },
        {
            text: "Materials",
            path: `/bill-of-materials-material/${id}`,
            applicationFeatureCode: "BillOfMaterial", // TODO : Change Accordingly
            disabled: disabledTab
        },
        {
            text: "Assembly",
            path: `/bill-of-materials-assembly/${id}`,
            applicationFeatureCode: "BillOfMaterial", // TODO : Change Accordingly
            disabled: disabledTab,
            visible: visibleAssemblyTab
        },
    ]
}

function GetIndexByTabName(tabName, baseView) {
    return tabAccessControl(BillOfMaterialsTabs(baseView)).findIndex((x) => x.text == tabName);
}


export { BillOfMaterialsTabs, GetIndexByTabName };
